import DrawingCanvas from "../coloring/objects/DrawingCanvas";
import { flump, assetLoader, audioPlayer } from "../PhaserExtension";
import * as States from "./States";
import * as GameModel from "../models/GameModel";
import PlayerDrawing from "../coloring/objects/PlayerDrawing";
import BaseState from "./BaseState";
import FlumpObject from "../general/objects/FlumpObject";

export default class ColoringState extends BaseState
{
    preload()
    {
        // Probably want the loading state to do this?
        assetLoader.preloadAssetPacks(this.game, ["coloring"]);
        this.game.load.image("colored", GameModel.data.storyImage.colored);
        this.game.load.image("outline", GameModel.data.storyImage.outline);
        this.game.load.addSyncPoint("image", "outline");

        if(GameModel.data.turn == "Muppet")
        {
            assetLoader.loadLocalizedAudio(this.game, "completeVO", GameModel.data.storyImage.muppetVO);
        }
        else
        {
            assetLoader.loadLocalizedAudio(this.game, "completeVO", GameModel.data.storyImage.playerVO);
        }

        if(GameModel.data.drawHistory.length < 5)
        {
            let fileName = "assets/coloring/audio/" + (GameModel.data.english ? "english" : "spanish") + "/s3_react_story";
            switch(GameModel.data.storyKey)
            {
                case "fish":
                    fileName += "1";
                    break;
                case "bees":
                    fileName += "2";
                    break;
                case "snow":
                    fileName += "3";
                    break;
                default:
                    console.error("invalid story");
                    break;
            }
            fileName += "_panel" + GameModel.data.drawHistory.length;
            this.game.load.audio("followupVO", [fileName + ".mp3", fileName + ".ogg"]);
        }

        super.preload();
    }

    create()
    {
        this.config = this.game.cache.getJSON("coloringConfig");
        flump.addLibrary(this.game, "coloringFlump", "assets/coloring/flump/");
        audioPlayer.setupChannels(this.config.sounds.channels);
        audioPlayer.play(this.game, this.config.sounds.music);

        this.game.stage.backgroundColor = 0xFCBD56;

        this.muppetHands = new FlumpObject(this.game, this.config.assets.hands, "coloringFlump");
        this.backgroundLayer.add(this.muppetHands);

        if(GameModel.data.turn == "Muppet")
        {
            this.muppetHands.loop(GameModel.data.storyImage.hands, true);
        }

        let subtitles = new Phaser.Text(this.game, this.game.width / 2, this.game.height / 2 + 187, GameModel.data.storyImage.storyText[+GameModel.data.english],
            {font:"SesameWorkshop", fontSize:22, fill:"black", align: "left", wordWrap: true, wordWrapWidth: 625, boundsAlignV: 'middle'});
        subtitles.anchor.setTo(0.5, 0);
        subtitles.textBounds = new Phaser.Rectangle(0, 0, 725, 135);
        let numLines = subtitles.precalculateWordWrap(GameModel.data.storyImage.storyText[+GameModel.data.english]).length;
        subtitles.lineSpacing = -3 - numLines;
        subtitles.fontSize = 32 - numLines * 2;
        this.foregroundLayer.add(subtitles);

        this.canvasX = this.config.assets.canvas.transform.position.x;
        this.canvasY = this.config.assets.canvas.transform.position.y;

        this.drawingBrush = new Phaser.Image(this.game, this.canvasX, this.canvasY, "brush");

        this.coloredImage = new Phaser.Image(this.game, this.canvasX, this.canvasY, "colored");
        this.maingroundLayer.add(this.coloredImage);

        this.outlineImage = new Phaser.Image(this.game, this.canvasX, this.canvasY, "outline");

        this.maskLayer = new DrawingCanvas(this.game, this.config.assets.canvas, this.drawingBrush, this.outlineImage);
        this.maingroundLayer.add(this.maskLayer);
        this.maskLayer.position.setTo(this.canvasX, this.canvasY);

        this.halfDone = false;
        this.hasPlayedVO = false;

        this.timeout = this.game.time.create(false);
        this.timeout.loop(10000, this.onTimeout, this);

        this.completeEffect = new FlumpObject(this.game, this.config.assets.completeEffect, "coloringFlump");
        this.completeEffect.visible = false;
        this.foregroundLayer.add(this.completeEffect);

        this.timeoutCount = 0;
        this.timeoutFiredTime = 0;
        GameModel.data.currentStateName = "Coloring Screen";

        super.create();
    }

    onTransitionInComplete()
    {
        this.drawManager = new PlayerDrawing(this.game,
            this.config.variables.playerDrawing,
            this.drawingBrush,
            this.maskLayer,
            this.sharedConfig.variables.isDebug);

        this.maingroundLayer.add(this.drawManager);
        this.drawManager.onComplete.addOnce(this.onColoringComplete, this);

        if(GameModel.data.drawHistory.length < 2)
        {
            audioPlayer.play(this.game, this.config.sounds.intro);
        }

        super.onTransitionInComplete();
        this.maskLayer.resetBrushPosition();
        this.timeout.start();
    }

    update()
    {
        if(this.drawManager && this.drawManager.canvas.drewThisFrame)
        {
            if(this.timeout)
            {
                this.timeout.stop(false);
                this.timeout.start();
                audioPlayer.stop(this.config.sounds.intro.trackKey[0], false);

                if(this.timeoutCount > 0)
                {
                    GameModel.sendEvent("TOReEnage", "Coloring Screen", Date.now() - this.timeoutFiredTime);
                }

                this.timeoutCount = 0;
            }

            if(!this.hasPlayedVO)
            {
                this.playVO();
            }
        }

        super.update();
    }

    onTimeout()
    {
        if(audioPlayer.play(this.game, this.config.sounds.intro))
        {
            if(this.timeoutCount == 0)
            {
                this.timeoutFiredTime = Date.now();
            }
            this.timeoutCount += 1;
            GameModel.sendEvent("TimeoutPlay", "Coloring Screen_Number_" + GameModel.fixNumber(this.timeoutCount));
        }
    }

    playVO()
    {
        audioPlayer.play(this.game, this.config.sounds.completeVO, this.partComplete, this);
        this.hasPlayedVO = true;
    }

    onColoringComplete()
    {
        audioPlayer.play(this.game, this.config.sounds.completeSFX);
        this.game.add.tween(this.maskLayer).to({alpha: 0}, 1000, Phaser.Easing.Linear.None, true)
                                           .onComplete.addOnce(this.partComplete, this);

        this.completeEffect.visible = true;
        this.completeEffect.playOnce(this.completeEffect.keys.idle, false, true);
        this.completeEffect.onComplete.addOnce(this.drawManager.finish, this.drawManager);
        this.completeEffect.onComplete.addOnce(this.completeEffect.kill, this.completeEffect);

        this.timeout.stop();
        this.timeout.destroy();
        this.timeout = null;

        GameModel.data.groverTransition = 2;
    }

    partComplete()
    {
        // Wait for both the VO and colouring to be complete.
        if(!this.halfDone)
        {
            this.halfDone = true;
            return;
        }

        this.game.time.events.add(Phaser.Timer.SECOND * 1, this.playReaction, this);
    }

    playReaction()
    {
        if(GameModel.data.drawHistory.length < 5)
        {
            audioPlayer.play(this.game, this.config.sounds.followup, this.transistionOut, this);
        }
        else
        {
            this.game.time.events.add(Phaser.Timer.SECOND * 1, this.transistionOut, this);
        }
    }

    onTransitionOutComplete()
    {
        if(GameModel.data.drawHistory.length >= GameModel.data.maxImages)
        {
            this.game.state.start(States.CONGRATULATIONS);
        }
        else
        {
            this.game.state.start(States.STORYCIRCLE);
        }
    }

    shutdown()
    {
        this.game.cache.removeImage("outline", true);
        this.game.cache.removeImage("colored", true);
        this.game.cache.removeSound("completeVO");
        if(GameModel.data.drawHistory.length < 5)
        {
            this.game.cache.removeSound("followupVO");
        }
        this.maskLayer.destroy(true);
        this.maskLayer = null;
        audioPlayer.cleanupChannels(this.config.sounds.channels);
        assetLoader.unloadAssetPacks(this.game, ["coloring"]);
        flump.removeLibrary("coloringFlump");
        this.drawManager = null;
        this.drawingBrush.destroy();
        this.outlineImage.destroy();
        this.coloredImage.destroy();
        delete this.drawingBrush;
        delete this.outlineImage;
        delete this.coloredImage;
        delete this.completeEffect;
        delete this.muppetHands;
        super.shutdown();
    }
}
